import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

import { css, Global } from '@emotion/react';

export const GlobalStyle = () => {
  return (
    <Global
      styles={css`
        @font-face {
          font-family: 'Telka Extended';
          src: url('/fonts/Telka/Telka-Extended-Regular.otf') format('opentype');
          font-weight: 400;
        }

        @font-face {
          font-family: 'Telka Extended';
          src: url('/fonts/Telka/Telka-Extended-Medium.otf') format('opentype');
          font-weight: 500;
        }

        @font-face {
          font-family: 'Telka Extended';
          src: url('/fonts/Telka/Telka-Extended-Bold.otf') format('opentype');
          font-weight: 700;
        }

        @font-face {
          font-family: 'Telka';
          src: url('/fonts/Telka/Telka-Regular.otf') format('opentype');
          font-weight: 400;
        }

        @font-face {
          font-family: 'Telka';
          src: url('/fonts/Telka/Telka-Medium.otf') format('opentype');
          font-weight: 500;
        }

        @font-face {
          font-family: 'Telka';
          src: url('/fonts/Telka/Telka-Bold.otf') format('opentype');
          font-weight: 700;
        }

        p {
          margin: 0; // Fix for bootstrap
        }
      `}
    />
  );
};
